module.exports = __webpack_public_path__ + "media/images/noticias/viejas/nuevo_edificio-e23138681a35e2c4ed6c36350375d992.jpg";